import { useEffect, useState } from "react";
import { Modal } from "@/components/ui/Modal";
import { loadBuildInfoRows, type BuildInfoRow } from "@/lib/buildInfo";

interface VersionModalProps {
  open: boolean;
  onClose: () => void;
}

export function VersionModal({ open, onClose }: VersionModalProps) {
  const [rows, setRows] = useState<BuildInfoRow[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!open) return;
    let cancelled = false;
    setError(null);
    loadBuildInfoRows()
      .then((next) => {
        if (!cancelled) setRows(next);
      })
      .catch((err: unknown) => {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : "Failed to load build information");
          setRows(null);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [open]);

  return (
    <Modal open={open} onClose={onClose} title="Build information" width="sm">
      {error ? <p className="form-error">{error}</p> : null}
      {!rows && !error ? <p className="muted">Loading build metadata…</p> : null}
      {rows ? (
        <dl className="info-list">
          {rows.map((row) => (
            <div key={row.label} className="info-list__row">
              <dt>{row.label}</dt>
              <dd>{row.value}</dd>
            </div>
          ))}
        </dl>
      ) : null}
    </Modal>
  );
}
